module.exports = __webpack_public_path__ + "static/media/plane.24d32901.svg";